module.exports = __webpack_public_path__ + "images/23d93f074a7ded8239ea80615a7d0dc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gb.svg
// module id = 1519
// module chunks = 1